import { $orQuerySearch } from '@utils/helpers/queryHelpers'

export const getQuery = (searchValue, fields, filters, hasSearchParam = false) => {
    const query: any = {}
    if (!hasSearchParam && searchValue?.trim() && fields?.length) {
        const searchQuery = $orQuerySearch(fields, searchValue?.trim())
        query.$or = searchQuery.$or
    }
    if (filters) {
        for (const fltKey in filters) {
            const filterValue = filters[fltKey]
            if (
                (filterValue || filterValue === 0 || filterValue === false) &&
                filterValue.toString()?.toLowerCase() !== 'all'
            ) {
                if (Array.isArray(filterValue) && !['$and'].includes(fltKey)) {
                    query[fltKey] = { $in: filterValue }
                } else {
                    query[fltKey] = filterValue
                }
            } else {
                delete query[fltKey]
            }
        }
    }
    return query
}

export const getValutFromKey = (data, key) => {
    const keys = key.split('.')
    let result = data
    keys.forEach(key => {
        result = result?.[key]
    })
    return result
}
